export default __webpack_public_path__ + "static/media/SAS Alert Tone 5.7c853524.mp3";